var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512c141.385 0 256-114.615 256-256S397.385 0 256 0 0 114.615 0 256s114.615 256 256 256Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.697 258.783H111.305c0 19.979 17.401 36.174 37.378 36.174h-1.204c0 19.979 16.195 36.174 36.174 36.174 0 19.979 16.195 36.174 36.174 36.174h72.348c19.979 0 36.174-16.195 36.174-36.174 19.979 0 36.174-16.195 36.174-36.174h-1.204c19.975 0 37.378-16.195 37.378-36.174Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.174 211.479c0 55.324-44.85 100.174-100.174 100.174-55.325 0-100.174-44.85-100.174-100.174",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.514 211.478-31.265 14.707 16.649 30.28-33.95-6.495-4.302 34.296-23.647-25.225-23.648 25.225-4.301-34.296-33.95 6.493 16.648-30.279-31.264-14.706 31.265-14.706-16.649-30.279 33.949 6.494 4.303-34.296 23.647 25.225 23.648-25.225 4.301 34.296 33.951-6.494-16.649 30.28 31.264 14.705Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKz);
export default __webpack_public_path__ + "static/media/kz.0f5df6ef97cd7259487c70757e613d74.svg";
export { ForwardRef as ReactComponent };